export enum DateFormat {
  /**
   * yyyy-MM-dd -> 2021-12-25
   */
  SERVER_DATE_FORMAT = 'yyyy-MM-dd',

  /**
   * dd.MM.yyyy -> 25.06.1977
   */
  DISPLAY_DATE_FORMAT = 'dd.MM.yyyy',

  /**
   * dd.MM.yyyy HH:mm -> 09.02.2021 15:20
   */
  DISPLAY_DATETIME_FORMAT = 'dd.MM.yyyy HH:mm',
}
